import React, { Component } from 'react';
import { Form, Radio } from 'antd';
import { language } from '../../../language';
import { ColorPicker, FormItemLayout, ConfigFormDecorator } from '../../tools';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;
/**
 * 辅助线线-配置表单
 */
class divider extends Component<any> {
    render() {
        const {
            form: { getFieldDecorator },
        } = this.props;
        const formItemLayout = FormItemLayout;
        return (
            <Form className="divider-form">
                <FormItem {...formItemLayout} label={language.getText('components.Divider.style')}>
                    {getFieldDecorator(
                        'style',
                        {}
                    )(
                        <RadioGroup className="fill-style">
                            <Radio value={'solid'}>
                                {language.getText('components.Divider.solid')}
                            </Radio>
                            <Radio value={'dashed'}>
                                {language.getText('components.Divider.dashed')}
                            </Radio>
                            <Radio value={'dotted'}>
                                {language.getText('components.Divider.dotted')}
                            </Radio>
                        </RadioGroup>
                    )}
                </FormItem>
                <FormItem {...formItemLayout} label={language.getText('components.Divider.color')}>
                    {getFieldDecorator('color')(<ColorPicker />)}
                </FormItem>
                <FormItem {...formItemLayout} label={language.getText('components.Divider.margin')}>
                    {getFieldDecorator('margin')(
                        <RadioGroup className="fill-style">
                            <Radio value={'none'}>
                                {language.getText('components.Divider.none')}
                            </Radio>
                            <Radio value={'space'}>
                                {language.getText('components.Divider.space')}
                            </Radio>
                        </RadioGroup>
                    )}
                </FormItem>
            </Form>
        );
    }
}

export const Divider = ConfigFormDecorator(divider);
